import { useDispatch, useSelector } from "react-redux";
import { waterCategories, airCategories, landCategories, snowCategories, bestViewsCategories } from "../../data/categoryList.js";
import { setNewFilters } from "../../redux/filtersSlice.js";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const flatArray = [
    ...waterCategories,
    ...airCategories,
    ...landCategories,
    ...snowCategories,
    ...bestViewsCategories
]

const CategorySlidebar = ({ isFixed }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const { filtersObject } = useSelector(state => state.filters);
    const handleClick = (label) => {
        if (label === filtersObject.category) {
            dispatch(setNewFilters({ category: null }))
        } else {
            dispatch(setNewFilters({ category: label }))
        }
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    // Gestisco il click per lo scorrimento
    const scrollContainerRef = useRef(null);
    const handleHorizontalScroll = (direction) => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({ left: direction === 'right' ? 400 : -400, behavior: 'smooth' })
        }
    }

    // Gestisco il scroll orizzontale e aggiorno isLeftShow e isRightShow
    const [isLeftShow, setIsLeftShow] = useState(false);
    const [isRightShow, setIsRightShow] = useState(true);
    const handleScroll = () => {
        if (scrollContainerRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
            // Mostra/nascondi la freccia sinistra
            setIsLeftShow(scrollLeft > 200);
            // Mostra/nascondi la freccia destr
            setIsRightShow(scrollLeft + clientWidth < scrollWidth - 200);
        }
    }

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
            scrollContainer.addEventListener('scroll', handleScroll);
        }
        // Cleanup
        return () => {
            if (scrollContainer) {
                scrollContainer.removeEventListener('scroll', handleScroll);
            }
        }
    }, []);

    return (
        <div className={`flex gap-2 items-center py-2 ${isFixed ? `fixed w-full top-[116px] md:top-[134px] left-0 right-0 z-20 bg-neutral-100 py-4 shadow-xl opacity-90` : 'mt-8 w-full lg:w-[800px] xl:w-[1200px] relative'}`}>
            <div className="flex gap-6 md:gap-16 overflow-x-auto whitespace-nowrap hide-scrollbar min-h-[86px] min-w-full" style={{ WebkitOverflowScrolling: 'touch' }} ref={scrollContainerRef}>
                {
                    filtersObject.activityType?.includes("Acqua") &&
                    waterCategories.map((element, index) => {
                            return <div key={index} className={`flex flex-col gap-1 items-center p-2 text-[8pt] w-fit text-center cursor-pointer border rounded-xl ${filtersObject.category === element.name ? 'border-neutral-300' : 'border-transparent'} ${index === 0 && 'ml-8'} ${element.name === 'Windsurf' && 'mr-16'}`}>
                                <img src={element.icon} alt={`${t(element.label)} icon`} className="min-w-12 h-12 cursor-pointer" onClick={() => handleClick(element.name)} />
                                <div>{t(element.shortLabel)}</div>
                            </div>
                    })
                }
                {
                    filtersObject.activityType?.includes("Aria") &&
                    airCategories.map((element, index) => {
                        return <div key={index} className={`flex flex-col gap-1 items-center p-2 text-[8pt] w-fit text-center cursor-pointer border rounded-xl ${filtersObject.category === element.name ? 'border-neutral-300' : 'border-transparent'} ${index === 0 && 'ml-8'} ${element.name === 'Volo in mongolfiera' && 'mr-16'}`}>
                            <img src={element.icon} alt={`${t(element.label)} icon`} className="min-w-12 h-12 cursor-pointer" onClick={() => handleClick(element.name)} />
                            <div>{t(element.shortLabel)}</div>
                        </div>
                    })
                }
                {
                    filtersObject.activityType?.includes("Terra") &&
                    landCategories.map((element, index) => {
                        return <div key={index} className={`flex flex-col gap-1 items-center p-2 text-[8pt] w-fit text-center cursor-pointer border rounded-xl ${filtersObject.category === element.name ? 'border-neutral-300' : 'border-transparent'} ${index === 0 && 'ml-8'} ${element.name === 'Zoo e parchi faunistici' && 'mr-16'}`}>
                            <img src={element.icon} alt={`${t(element.label)} icon`} className="min-w-12 h-12 cursor-pointer" onClick={() => handleClick(element.name)} />
                            <div>{t(element.shortLabel)}</div>
                        </div>
                    })
                }
                {
                    filtersObject.activityType?.includes("Neve") &&
                    snowCategories.map((element, index) => {
                        return <div key={index} className={`flex flex-col gap-1 items-center p-2 text-[8pt] w-fit text-center cursor-pointer border rounded-xl ${filtersObject.category === element.name ? 'border-neutral-300' : 'border-transparent'} ${index === 0 && 'ml-8'} ${element.name === 'Slittino, bob e Skitti' && 'mr-16'}`}>
                            <img src={element.icon} alt={`${t(element.label)} icon`} className="min-w-12 h-12 cursor-pointer" onClick={() => handleClick(element.name)} />
                            <div>{t(element.shortLabel)}</div>
                        </div>
                    })
                }
                {
                    filtersObject.activityType?.includes("Best Views") &&
                    bestViewsCategories.map((element, index) => {
                        return <div key={index} className={`flex flex-col gap-1 items-center p-2 text-[8pt] w-fit text-center cursor-pointer border rounded-xl ${filtersObject.category === element.name ? 'border-neutral-300' : 'border-transparent'} ${index === 0 && 'ml-8'} ${element.name === 'Slittino, bob e Skitti' && 'mr-16'}`}>
                            <img src={element.icon} alt={`${t(element.label)} icon`} className="min-w-12 h-12 cursor-pointer" onClick={() => handleClick(element.name)} />
                            <div>{t(element.shortLabel)}</div>
                        </div>
                    })
                }
                {
                    !filtersObject.activityType &&
                    flatArray.map((element, index) => {
                        return <div key={index} className={`flex flex-col gap-1 items-center p-2 text-[8pt] w-fit text-center cursor-pointer border rounded-xl ${filtersObject.category === element.name ? 'border-neutral-300' : 'border-transparent'} ${index === 0 && 'ml-8'} ${element.name === 'Slittino, bob e Skitti' && 'mr-16'}`}>
                            <img src={element.icon} alt={`${element.label} icon`} className="min-w-12 h-12 cursor-pointer" onClick={() => handleClick(element.name)} />
                            <div>{t(element.shortLabel)}</div>
                        </div>
                    })
                }
            </div>
            {/* LEFT ARROW */}
            <div className={`absolute left-0 ${isLeftShow ? 'hidden md:flex' : 'hidden'} justify-center items-center w-24 h-full bg-gradient-to-r from-neutral-100 to-transparent`}>
                <div className="pt-2 pr-2.5 pl-2 pb-0.5 border rounded-full bg-white cursor-pointer w-fit h-fit" onClick={() => handleHorizontalScroll('left')}><i className="fi fi-br-angle-left text-xl"></i></div>
            </div>
            {/* RIGHT ARROW */}
            <div className={`absolute right-0 ${isRightShow ? 'hidden md:flex' : 'hidden'} justify-center items-center w-24 h-full bg-gradient-to-l from-neutral-100 to-transparent`}>
                <div className="pt-2 pr-2 pl-2.5 pb-0.5 border rounded-full bg-white cursor-pointer w-fit h-fit" onClick={() => handleHorizontalScroll('right')}><i className="fi fi-br-angle-right text-xl"></i></div>
            </div>

        </div >
    )
}

export default CategorySlidebar